import { render } from "./ConfigListaGridsTelasView.vue?vue&type=template&id=c3b5d10e"
import script from "./ConfigListaGridsTelasView.vue?vue&type=script&lang=js"
export * from "./ConfigListaGridsTelasView.vue?vue&type=script&lang=js"

import exportComponent from "C:\\SGCAD25\\Multifianca\\FrontBack\\CodigoVue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__